import React from 'react'
import styled from 'styled-components'
import Spinner from '../spinner'
import Delayed from "../delayed";

const LoaderContainer = styled.div`
  left: 50%;
  position: fixed; 
  top: 50%;
  z-index: 99999999;
  background: #FFFFFF;
  padding: 20px;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.10), 0 16px 32px 0 rgba(0,0,0,0.20);
  border-radius: 4px;
  margin-left: -65px;
  margin-top: -57px;
  
  > * {
    margin: 5px 10px;
  }
`;
export default class WholeScreenLoader extends React.PureComponent {
  render() {
    const { pastDelay, error } = this.props;
    if(error) {
      console.log('error', error);
    }

    let loader = (
      <Delayed>
        <LoaderContainer><Spinner /></LoaderContainer>
      </Delayed>
    );
    return loader
  }
}
